import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { getCurrentStoreNumber } from 'selectors/getCurrentStore'
import { USER_PLAN_DROP_OFF } from 'constant'
import RequestSentBlock from './RequestSentBlock'

dayjs.extend(calendar)

const formatPhoneNumber = phoneNumber =>
  `(${phoneNumber.areaCode}) ${phoneNumber.firstThree}-${phoneNumber.lastFour}`

const formatAddress = (address, storeNumber) =>
  `${address.address1}, ${address.city}  ${address.state} ${address.zipcode}  [#${storeNumber}]`

const formatDate = (date, time) => {
  const formattedDate = dayjs(date, 'MM/DD/YYYY')
    .calendar(null, {
      lastDay: 'MMMM D, YYYY',
      sameDay: '[Today], MMMM D, YYYY',
      nextDay: '[Tomorrow], MMMM D, YYYY',
      lastWeek: 'MMMM D, YYYY',
      nextWeek: 'dddd, MMMM D, YYYY',
      sameElse: 'dddd, MMMM D, YYYY'
    })

  return `${formattedDate}, ${time}`
}

const formatServiceList = serviceList =>
  serviceList.map(item => item.serviceName.trim()).join(', ')

const formatUserPlan = userPlan =>
  userPlan === USER_PLAN_DROP_OFF ? 'Drop off' : 'Wait'

const formatPromotionsList = promotions => promotions && promotions.length
  ? promotions[0].promotionShortDescription
  : null

const mapStateToProps = ({
  appointment: {
    appointmentResponse: {
      orderReviewContactDetails: {
        firstName,
        lastName,
        emailId,
        primaryPhone
      },
      orderReviewVehicleDetails: {
        vehicleNickname
      },
      orderReviewAppointmentDetails: {
        storeAddress,
        appontmentDate,
        dropOffTime,
        userPlan
      },
      selectedServiceItems: {
        selectedServiceDetailsList
      }
    },
    activePromotions
  },
  ...state
}) => ({
  fields: [
    { name: 'Name:', value: `${firstName} ${lastName}`, id: 'name' },
    { name: 'Phone:', value: formatPhoneNumber(primaryPhone), id: 'phone' },
    { name: 'Email:', value: emailId, id: 'email' },
    { name: 'Vehicle:', value: vehicleNickname, id: 'vehicle' },
    { name: 'Store Location:', value: formatAddress(storeAddress, getCurrentStoreNumber(state)), id: 'store-location' },
    { name: 'Service(s) Requested:', value: formatServiceList(selectedServiceDetailsList), id: 'services' },
    {
      name: 'Potential Savings:',
      value: formatPromotionsList(activePromotions),
      id: 'potential-savings'
    },
    { name: 'Date & Time Requested:', value: formatDate(appontmentDate, dropOffTime), id: 'date-time-requested' },
    { name: 'Drop-off or Wait:', value: formatUserPlan(userPlan), id: 'user-plan' }
  ],
  storePhoneNumber: storeAddress.phoneNumber
})

const withRequestSentBlockProps = withProps(({ isE2EAppointment }) => ({
  isE2EAppointment
}))

export default compose(
  connect(mapStateToProps),
  withRequestSentBlockProps
)(RequestSentBlock)
